// src/scripts/fluco-lib/a11y.js
var handleTab = () => {
  const classes = {
    userIsTabbing: "fluco-user-is-tabbing"
  };
  const formElements = ["input", "textarea", "select"];
  function handleFirstTab(event) {
    if (event.key === "Tab" && !formElements.includes(document.activeElement.tagName.toLowerCase())) {
      document.body.classList.add(classes.userIsTabbing);
      window.addEventListener("mousedown", handleMouseDownOnce);
      window.removeEventListener("keydown", handleFirstTab);
    }
  }
  function handleMouseDownOnce() {
    document.body.classList.remove(classes.userIsTabbing);
    window.addEventListener("keydown", handleFirstTab);
    window.removeEventListener("mousedown", handleMouseDownOnce);
  }
  window.addEventListener("keydown", handleFirstTab);
};
var prefersReducedMotion = () => {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

// src/scripts/fluco-lib/debounce.js
function debounce() {
  let timer;
  return function(func, time = 100) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time);
  };
}

// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/fluco-lib/pauseable-interval.js
var PauseableInterval = class {
  constructor(callback, delay) {
    this.callback = callback;
    this.delay = delay;
    this.pausedTimeLeft = 0;
    this.timerIsPaused = false;
    this.timerHasPaused = false;
    this.triggerSetAt = (/* @__PURE__ */ new Date()).getTime();
    this.timer = setInterval(this.callback, this.delay);
  }
  reset() {
    this.#clearTimer();
    this.pausedTimeLeft = 0;
    this.timerIsPaused = false;
    this.timerHasPaused = false;
    this.triggerSetAt = (/* @__PURE__ */ new Date()).getTime();
    this.timer = setInterval(this.callback, this.delay);
  }
  clear() {
    this.#clearTimer();
  }
  #getTimeLeft() {
    const now = /* @__PURE__ */ new Date();
    const timeLeft = this.timerHasPaused ? this.pausedTimeLeft : this.delay;
    return timeLeft - (now - this.triggerSetAt) % this.delay;
  }
  pause() {
    this.pausedTimeLeft = this.#getTimeLeft();
    this.timerIsPaused = true;
    this.timerHasPaused = true;
    this.#clearTimer();
  }
  resume() {
    this.triggerSetAt = (/* @__PURE__ */ new Date()).getTime();
    this.timer = setTimeout(() => {
      this.callback();
      this.reset();
    }, this.pausedTimeLeft);
  }
  #clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
  isPaused() {
    return this.timerIsPaused;
  }
};
var pauseable_interval_default = PauseableInterval;

// src/scripts/sections/announcement-bar.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
handleTab();
var AnnouncementBar = class extends HTMLElement {
  constructor() {
    super();
    this.debounce = debounce();
    this.selectors = {
      announcementSlider: "fluco-announcement-slider"
    };
  }
  connectedCallback() {
    this.sliderComponent = this.querySelector(this.selectors.announcementSlider);
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (e) => this.handleBlockSelected(e.detail.blockId),
      this.eventOptions
    );
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      () => this.handleBlockDeselected(),
      this.eventOptions
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
    this.widthWatcher?.destroy();
  }
  /**
   * Pauses the slider and changes to the selected block's slide.
   * @param {String} blockId - The block ID for the selected block.
   */
  handleBlockSelected(blockId) {
    this.setSliderAutoplay("false");
    this.setSliderActiveBlock(blockId);
  }
  /**
   * Resumes the slider and resets the selected block.
   */
  handleBlockDeselected() {
    this.setSliderAutoplay("true");
    this.setSliderActiveBlock("");
  }
  /**
   * Sets the slider's autoplay attribute value.
   * @param {String} value - The autoplay state, as either "true" or "false".
   */
  setSliderAutoplay(value) {
    if (this.sliderComponent) {
      this.sliderComponent.dataset.autoplay = value;
    }
  }
  /**
   * Sets the slider's active block id.
   * @param {String} blockId - The block ID for the selected block.
   */
  setSliderActiveBlock(blockId) {
    if (this.sliderComponent) {
      this.sliderComponent.dataset.activeBlockId = blockId;
    }
  }
};
var AnnouncementSlider = class extends HTMLElement {
  static observedAttributes = ["data-autoplay", "data-active-block-id"];
  connectedCallback() {
    this.slider = this.querySelector("[js-slider]");
    this.sliderItemsArray = Array.from(this.slider.children);
    this.sliderItemsCount = Array.from(this.slider.children).length;
    const { autoplay, autoplayDelay } = this.dataset;
    this.autoplayDelay = parseInt(autoplayDelay, 10);
    this.shouldAutoplay = autoplay === "true";
    if (this.shouldAutoplay) {
      this.autoplay = new pauseable_interval_default(
        this.showNextSlide.bind(this),
        this.autoplayDelay
      );
    }
    this.prevButton = this.querySelector("[js-prev-button]");
    this.nextButton = this.querySelector("[js-next-button]");
    this.eventController = new AbortController();
    const eventOptions = {
      signal: this.eventController.signal
    };
    this.prevButton.addEventListener(
      "click",
      () => this.showPrevSlide(),
      eventOptions
    );
    this.nextButton.addEventListener(
      "click",
      () => this.showNextSlide(),
      eventOptions
    );
    if (this.shouldAutoplay) {
      this.addEventListener(
        "mouseenter",
        () => this.autoplay.pause(),
        eventOptions
      );
      this.addEventListener(
        "mouseleave",
        () => this.autoplay.reset(),
        eventOptions
      );
      this.addEventListener(
        "focusin",
        () => this.autoplay.pause(),
        eventOptions
      );
      this.addEventListener(
        "focusout",
        () => this.autoplay.reset(),
        eventOptions
      );
    }
    this.setActiveSlide(0, null, "up");
  }
  disconnectedCallback() {
    this.eventController.abort();
    this.autoplay?.clear();
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case "data-autoplay":
        newValue === "true" ? this.autoplay?.reset() : this.autoplay?.pause();
        break;
      case "data-active-block-id":
        if (!newValue) break;
        this.showBlockSlide(newValue);
    }
  }
  /** Shows the previous slide. Always loops. */
  showPrevSlide() {
    const activeSlideIndex = this.getActiveSlideIndex();
    const prevSlideIndex = activeSlideIndex > 0 ? activeSlideIndex - 1 : this.sliderItemsCount - 1;
    this.setActiveSlide(prevSlideIndex, activeSlideIndex, "down");
  }
  /** Shows the next slide. Always loops. */
  showNextSlide() {
    const activeSlideIndex = this.getActiveSlideIndex();
    const nextSlideIndex = activeSlideIndex < this.sliderItemsCount - 1 ? activeSlideIndex + 1 : 0;
    this.setActiveSlide(nextSlideIndex, activeSlideIndex, "up");
  }
  /**
   * Shows the slide corresponding with the block ID. Used for the theme editor.
   * @param {String} blockId - The block ID for the selected block.
   */
  showBlockSlide(blockId) {
    const activeSlideIndex = this.getActiveSlideIndex();
    const blockSlideIndex = this.sliderItemsArray.findIndex(
      (element) => element.dataset.shopifyEditorBlock.includes(blockId)
    );
    this.setActiveSlide(blockSlideIndex, activeSlideIndex, "up");
  }
  /**
   * Gets the active slide index.
   * @returns {Number} The index of the currently active slide.
   */
  getActiveSlideIndex() {
    return parseInt(this.slider.dataset.activeSlideIndex, 10);
  }
  /**
   * Changes the active slide, while ensuring the animation plays in the correct direction.
   * @param {Number} activeIndex - The updated index for the active slide.
   * @param {Number} lastIndex - The index of the most recently deactivated slide.
   * @param {String} direction - The direction of the translation animation. Can be "up" or "down".
   */
  setActiveSlide(activeIndex, lastIndex, direction) {
    this.slider.dataset.activeSlideIndex = activeIndex;
    this.slider.dataset.slideDirection = direction;
    this.sliderItemsArray.forEach((element, index) => {
      element.toggleAttribute("inert", index !== activeIndex);
      index === activeIndex ? element.dataset.slideActive = "true" : element.dataset.slideActive = "false";
      index === lastIndex ? element.dataset.slideOutgoing = "true" : element.dataset.slideOutgoing = "false";
    });
  }
};
var AnnouncementScroller = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (prefersReducedMotion()) return;
    const marquee = this.querySelector("[js-marquee]");
    const content = this.querySelector("[js-marquee-content]");
    const clonedContent = this.tabProofClonedContent(content.cloneNode(true));
    const contentWidth = content.offsetWidth;
    if (contentWidth === 0) return;
    this.ro = new ResizeObserver(() => {
      const num = this.getNeededCloneCount(this, marquee, content);
      for (let i = 0; i < num; i++) {
        marquee.dataset.playScrollAnimation = "false";
        marquee.appendChild(clonedContent.cloneNode(true));
      }
      requestAnimationFrame(() => {
        marquee.dataset.playScrollAnimation = "true";
      });
    });
    this.ro.observe(document.documentElement);
  }
  disconnectedCallback() {
    this.ro?.disconnect();
  }
  /**
   * Checks to see if more content clones are needed in order to keep the scroll animation seamless.
   * @param {HTMLElement} viewport - The resized element acting as the viewport
   * @param {HTMLElement} marquee - The element that must be wider than the viewport
   * @param {HTMLElement} content - The element to be repeated
   * @returns {Number} The number of content clones needed to fill the new viewport
   */
  getNeededCloneCount(viewport, marquee, content) {
    const viewportWidth = viewport.offsetWidth;
    const marqueeWidth = marquee.offsetWidth;
    const contentWidth = content.offsetWidth;
    return Math.ceil((viewportWidth - marqueeWidth) / contentWidth) + 1;
  }
  /**
   * Ensures that:
   * - Any cloned links are not tabbable
   * - Any cloned content has aria-hidden applied
   * @param {HTMLElement} clonedContent - The cloned content
   * @returns {HTMLElement} The accessible cloned content
   */
  tabProofClonedContent(clonedContent) {
    const linkEls = clonedContent.querySelectorAll("a, button");
    linkEls.forEach((linkEl) => {
      linkEl.setAttribute("tabindex", "-1");
    });
    clonedContent.setAttribute("aria-hidden", true);
    return clonedContent;
  }
};
if (!customElements.get("fluco-announcement-bar")) {
  customElements.define("fluco-announcement-bar", AnnouncementBar);
}
if (!customElements.get("fluco-announcement-slider")) {
  customElements.define("fluco-announcement-slider", AnnouncementSlider);
}
if (!customElements.get("fluco-announcement-scroller")) {
  customElements.define("fluco-announcement-scroller", AnnouncementScroller);
}
